import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input, message } from "antd";
import auth1 from "../../../assets/images/auth/bg.png";
import axios from "axios";
import { SERVER_ADDRESS } from "../../../Config/Config";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/login`, values);
      if (response.status === 200 && response.data.result === 1) {
        message.success({ content: "Logged In successfully", duration: 2 });
        localStorage.setItem("token", response.data.token);
        navigate("/frontend/dashboard/category/category-list");
        setLoading(false);
      } else {
        message.warning({ content: `${response.data.message}` });
        setLoading(false);
      }
    } catch (error) {
      message.error({ content: "Internal Server Error", duration: 2 });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login-content">
        <div className="background-overlay"></div>

        <Row className="m-0 align-items-center justify-content-center vh-100">
          <Col xs={12} md={6} lg={4} className="glass-form p-5 rounded">
            <div className="text-center mb-4">
              <h2 style={{ color: "white" }}>Iconstoolkit Admin Login</h2>
            </div>
            <Form
              form={form}
              name="login"
              initialValues={{ remember: true }}
              layout="vertical"
              style={{ width: "100%" }}
              onFinish={handleLogin}
            >
              <Form.Item
                label={<span className="text-white">Email</span>}
                name="email"
                rules={[
                  { required: true, message: "Please input your Email!" },
                ]}
              >
                <Input prefix={<UserOutlined />} placeholder="Enter Email" />
              </Form.Item>

              <Form.Item
                label={<span className="text-white">Password</span>}
                name="password"
                rules={[
                  { required: true, message: "Please input your Password!" },
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter Password"
                />
              </Form.Item>

              <Form.Item>
                <Button loading={loading} block type="primary" htmlType="submit">
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </section>

      {/* CSS Styles */}
      <style>{`
            .background-overlay {
               background: url(${auth1}) no-repeat center center fixed;
               background-size: cover;
               background-color:#4d71bede;
               position: absolute;
               width: 100%;
               height: 100%;
               filter: blur(10px);
               top: 0;
               left: 0;
               z-index: -1;
            }

            .glass-form {
               background: rgba(0, 0, 0, 0.6); /* smoky black */
               border-radius: 16px;
               box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6); /* stronger shadow for smoke effect */
               backdrop-filter: blur(12px); /* glass blur */
               -webkit-backdrop-filter: blur(12px);
               border: 1px solid rgba(255, 255, 255, 0.1); /* thin white border for contrast */
               }

               /* Input styling */
               .glass-form input {
               background: rgba(255, 255, 255, 0.1); /* very subtle transparent input */
               border: none;
               color: #fff;
               }

               .glass-form input::placeholder {
               color: grey; /* faded white placeholder */
               }

               /* Labels */
               .glass-form .ant-form-item-label > label {
               color: #ddd; /* softer white text */
               }
         `}</style>
    </>
  );
};

export default SignIn;
